import React from "react";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { getTableDateTime } from "helpers/dateUtils/getTableDateTime";
import { FieldLabel } from "common/fieldLabel/FieldLabel";
import { Typography } from "@mui/material";

interface IDateTimePickerProps {
  label: string;
  placeholder?: string;
  hideLabel?: boolean;
  asUtc?: boolean;
  disabled?: boolean;
  timeSteps?: { minutes: number };
  onChange: (value: string) => void;
  onAccept: (value: string) => void;
  setValue: (value: string) => void;
  value: Date | null;
  isTouched?: boolean;
  errorMessage?: string;
  labelId: string;
  required?: boolean;
}
export const DateTimePicker: React.FC<IDateTimePickerProps> = ({
  labelId,
  label,
  placeholder,
  hideLabel = false,
  disabled,
  timeSteps,
  onAccept,
  setValue,
  value,
  errorMessage,
  isTouched = false,
  asUtc,
  required,
}) => {
  const handleOnChange = (date: Date | null) => {
    if (date) {
      setValue(asUtc ? date.toISOString() : getTableDateTime(date));
    }
  };
  const renderDateTimePicker = (
    <>
      <DesktopDateTimePicker
        value={value}
        onChange={(date) => handleOnChange(date)}
        onAccept={(value) => onAccept?.(getTableDateTime(value))}
        ampm
        disabled={disabled}
        timeSteps={timeSteps}
        slotProps={{
          textField: {
            "aria-label": label,
            "aria-labelledby": labelId,
            variant: "outlined",
            size: "small",
            fullWidth: true,
            label: "",
            error: !!(errorMessage && isTouched),
            placeholder,
            InputLabelProps: {
              shrink: true,
            },
            sx: {
              backgroundColor: "white",
              borderRadius: 1,
            },
          },
        }}
      />
      {errorMessage && isTouched && (
        <Typography variant="caption" color="error">
          {errorMessage}
        </Typography>
      )}
    </>
  );
  if (hideLabel) {
    return renderDateTimePicker;
  }
  return (
    <FieldLabel label={label} labelId={labelId} required={required}>
      {renderDateTimePicker}
    </FieldLabel>
  );
};
